import { render, staticRenderFns } from "./DashboardLeads.vue?vue&type=template&id=2379318f"
import script from "./DashboardLeads.vue?vue&type=script&lang=js"
export * from "./DashboardLeads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports